import fetchLocation from "utils/fetch-locations"
import fetchSocialMedia from "utils/fetch-social-media"
import LandingpageLayout from "../../components/LandingpageLayout"
import DynamicContent from "../../components/content/DynamicContent"
import { createApolloClient } from "../../utils/apollo"
import { buildDetailQuery } from "../../utils/blueprints/landingpages"
import fetchCompany from "../../utils/fetch-company"
import fetchNav from "../../utils/fetch-nav"
import fetchSlugs from "../../utils/fetch-slugs"
import { replaceVariables } from "../../utils/replaceVariables"
import MetaTracking from "../../components/MetaTracking/MetaTracking"

function CatchAllLandingPage({
  content = {},
  navs,
  company = {},
  locations,
  socialMediaLinks,
}) {
  return (
    <LandingpageLayout
      company={company}
      navs={navs}
      content={content}
      locations={locations}
      socialMediaLinks={socialMediaLinks}
    >
      <MetaTracking
        enabled={content?.enable_meta_tracking}
        tracking_id={content?.meta_tracking_id}
      />
      {content?.intro && (
        <div className={"container"}>
          <h2
            className={"hero py-20"}
            dangerouslySetInnerHTML={{ __html: content.intro }}
          />
        </div>
      )}
      <DynamicContent content={content} />
    </LandingpageLayout>
  )
}

// Data for current page
//
export const getStaticProps = async (context) => {
  const slug = context.params.slug
  const { previewData } = context

  const apollo = createApolloClient(previewData?.token ?? null)

  const [res, navs, company, locations, socialMediaLinks] = await Promise.all([
    apollo.query({
      query: buildDetailQuery({
        slug,
        isPreview: !!context?.previewData?.token,
        unit: context?.previewData?.unit,
      }),
    }),
    fetchNav(apollo, previewData?.unit),
    fetchCompany(apollo, previewData?.unit),
    fetchLocation(apollo, previewData?.unit),
    fetchSocialMedia(apollo, previewData?.unit),
  ])

  if (res.errors?.length) {
    console.error("landingpage error:", res)
    throw new Error(res.errors[0]?.message)
  }

  const content = (res?.data?.entries?.data || [])?.filter((e) => !!e)?.[0]

  if (!content) {
    return {
      notFound: true,
    }
  }

  return {
    props: {
      navs,
      content: await replaceVariables(content),
      company,
      locations,
      socialMediaLinks,
    },
    // revalidate: 30,
  }
}

// Generate static paths for SSR
export const getStaticPaths = async () => {
  let paths = await fetchSlugs("landingpages")
  paths = paths.map((path) => path.url)

  console.log({ paths })

  return {
    paths,
    fallback: false,
  }
}

export default CatchAllLandingPage
